type ApiUrlName =
  | 'createSaveQuotationIdHistory'
  | 'defaultCustomRate'
  | 'legalNote'
  | 'listByVehicle'
  | 'montlyRateCalculation'
  | 'oAuth'
  | 'productsRate'
  | 'retrieveQuotationIdData'
  | 'serviceDescription';

const API_URLS: Record<ApiUrlName, string> = {
  createSaveQuotationIdHistory:
    '/history-module/v1/create-save-quotationId-history',
  defaultCustomRate: '/financialsimulation/v1/default-custom-rate',
  legalNote: '/price/v1/legal-note',
  listByVehicle: '/master-agreement/v1/list-by-vehicle',
  montlyRateCalculation: '/price/v1/monthly-rate-calculation',
  oAuth: '/oauth2/v1/token',
  productsRate: '/master-agreement/v1/list-by-vehicle',
  retrieveQuotationIdData: '/history-module/v1/retrieve-quotationId-data',
  serviceDescription: '/master-agreement/v1/service-description'
};

const API_URLS_MOCK: Record<ApiUrlName, string> = {
  createSaveQuotationIdHistory:
    '/history-module/v1/create-save-quotationId-history',
  defaultCustomRate: '/defaultCustomRate',
  legalNote: '/legalNote',
  listByVehicle: '/master-agreement/v1/list-by-vehicle',
  montlyRateCalculation: '/price/v1/monthly-rate-calculation',
  oAuth: '/oauth-token',
  productsRate: '/productsRate',
  retrieveQuotationIdData: '/history-module/v1/retrieve-quotationId-data',
  serviceDescription: '/master-agreement/v1/service-description'
};
declare global {
  interface Window {
    mock: boolean;
  }
}

export const getApiUrl = (
  name: ApiUrlName,
  params?: Record<string, number | string>
): string => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  let path = !window.mock ? API_URLS[name] : API_URLS_MOCK[name];

  if (params) {
    Object.keys(params).forEach((key) => {
      const value = params[key];
      path = path.replace(`:${key}`, value.toString());
    });
  }

  return `${baseUrl}${path}`;
};
